const predicate =
  (monthsSelected: number[]) =>
  (itinerary): boolean => {
    const month = new Date(
      itinerary.legs[0].segments[0].sections[0].departureDate
    ).getMonth();
    return monthsSelected.length === 0 || monthsSelected.includes(month);
  };

export default predicate;
